import React from "react";
import { Link } from "react-router-dom";
import "./DashboardPage.css";

function DashboardPage() {
  return (
    <div className="dashboard-landing-page">
      <h2 className="welcome-header">
        Welcome to Your Snakes & Ladders Dashboard
      </h2>
      <p className="status-info">
        Everything you need to manage your team and track your progress.
      </p>

      <div className="dashboard-widgets">
        <div className="widget">
          <h3>My Profile</h3>
          <p>Update your linked IGNs and view your stats.</p>
          <Link to="/profile">Go to Profile</Link>
        </div>

        <div className="widget">
          <h3>My Games</h3>
          <p>See your current games and their status.</p>
          <Link to="/games">View My Games</Link>
        </div>

        <div className="widget">
          <h3>Spectate Live Games</h3>
          <p>Watch ongoing games and check live progress.</p>
          <Link to="/games/spectate-auth">Spectate Games</Link>
        </div>

        <div className="widget">
          <h3>Platform Guide</h3>
          <p>Need help getting started? Check out our walkthrough.</p>
          <Link to="/guide">View Guide</Link>
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;
